<template>
  <div class="home">
    <div class="container my-3 py-3 px-4">
      <div class="row">
        <div class="col-12">
          <h2 class="text-start">Notifications</h2>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-3 col-lg-3 ms-auto">
          <button
            class="btn btn-primary w-100"
            @click="goToCreateNewNotification">
            <i class="bi bi-plus-circle-fill"></i> New notification
          </button>
        </div>
      </div>
      <div>
        <div
          class="row py-5"
        >
          <table
            class="table table-responsive table-hover text-start rounded-3"
          >
            <thead id="table-headers" class="table-primary">
              <tr>
                <th scope="col">Recipients</th>
                <th scope="col">Title</th>
                <th scope="col">Message</th>
                <th scope="col">Sent</th>
                <th scope="col">Sent date</th>
                <th scope="col">Actions</th>
              </tr>
            </thead>
            <tbody id="table-body">
              <tr
                class="text-start cursor-pointer m-0 p-0"
                v-for="(notification, index) in notifications" :key="index"
              >
                <td header="Recipients" :title="notification.recipients" scope="row" class="word-wrap"> {{ notification.recipients }} </td>
                <td header="Title" :title="notification.title" scope="row" class="word-wrap"> {{ notification.title }} </td>
                <td header="Message" :title="notification.body" scope="row" class="word-wrap"> {{ notification.body }} </td>
                <td header="Sent" scope="row" class="word-wrap">Yes</td>
                <td header="Sent date" scope="row" class="word-wrap">{{ formatDate(notification.updatedAt) }}</td>
                <td header="Actions" class="word-wrap">
                  <button
                    class="btn btn-label"
                    title="Send again"
                    @click="sendNotificationById(notification.id)"
                  >
                    <i class="bi bi-send-fill"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { getAllNotifications, sendByNotificationId } from '@/services/notifications/notification.api.js'

export default {
  components: {},
  name: 'ManageNotifications',
  data() {
    return {
      notifications: [],
    }
  },
  async mounted() {
    await this.getNotifications();
  },
  methods: {
    formatDate(updatedAt) {
      const date = new Date(updatedAt);
      return date.toLocaleString("en-US");
    },
    async getNotifications(){
      try {
        const {data} = await getAllNotifications();
        this.notifications = data.notifications
      } catch (error) {
        console.log(error)
      }
    },
    goToCreateNewNotification() {
      this.$router.push(`/notifications/create`)
    },
    async sendNotificationById(notificationId) {
      await sendByNotificationId(notificationId);
      await this.getNotifications();
    },
  },
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>